export const QueryNames = {
    loadSearch: "loadSearch",
    lorrySearch: "lorrySearch",
    loadsForCurrentUser: "loadsForCurrentUser",
    lorriesForCurrentUser: "lorriesForCurrentUser",
    postLoad: "postLoad",
    postLorry: "postLorry",
    bidHistory: "bidHistory",
    validateToken: "validateToken",
    routesByCompanyId: "routesByCompanyId",
    userProfile: "userProfile",
    getDigilockerVerificationUrl: "getDigilockerVerificationUrl",
    businessCardDetails: "businessCardDetails",
    bidTransaction: "bidTransaction",
    companyAddressList: "companyAddressList",
    companyReviewList: "companyReviewList",
    companyRouteDetails: "companyRouteDetails",
    transporters: {
        getTransporterList: "getTransporterList"
    },
    userLorries: {
        getLorriesByCategory: "getLorriesByCategory",
        getLorryById: "lorryInfoById",
        getLorryRoutes: "lorryRoutes",
        getLorriesByCompanyId: "lorriesByCompanyId",
        getLorryBidsById: "lorryBidsById",
        getLorryInfoById: "lorryInfoById",
        getLiveLorries: "getLiveLorries",
        deactivateLorry: "deactivateLorry",
        deleteLorry: "deleteLorry",
        reactivateLorry: "reactivateLorry",
        verifyLorryFromSignzy: "verifyLorryFromSignzy"
    },
    userLoads: {
        getLoadsByCompanyId: "loadsByCompanyId",
        getLoadInfoById: "loadInfoById",
        getLoadBidsById: "loadBidsById",
        getLiveLoads: "getLiveLoads",
        getTransportersByLoadId: "getTransportersByLoadId",
        deactivateLoadById: "deactivateLoadById",
        adminVerifyLoad: "adminVerifyLoad",
        adminDeactivateLoad: "adminDeactivateLoad",
        getLoadStops: "getLoadStops",
        getAggregateBidByCompanyId: "getAggregateBidByCompanyId"
    },

    loadComments: {
        addLoadComment: "addLoadComment",
        getLoadComment: "getLoadComment"
    },

    lorryComments: {
        addLorryComment: "addLorryComment",
        getLorryComment: "getLorryComment"
    },
    premium: {
        getSimTrack: "getSimTrack"
    },
    ticketSystem: {
        createTicket: "createTicket",
        getTickets: "getTickets",
        getLoadTicket: "getLoadTicket",
        updateTicketStatus: "updateTicketStatus",
        getTicketById: "getTicketById",
        tagUser: "tagUser",
        untagUser: "untagUser",
        getLoadByDisposition: "getLoadByDisposition",
        getDispositionHistory: "getDispositionHistory",
        assignTicket: "assignTicket"
    },
    blockUser: "blockUser",
    unBlockUser: "unBlockUser",
    sendWhatsAppMessage: "sendWhatsAppMessage",
    getCashbackStatus: "getCashbackStatus",
    editLorry: "editLorry",
    editLoad: "editLoad",
    auth: {
        sendOTP: "sendOTP",
        sendWaOTP: "sendWaOTP",
        verifyOtp: "verifyOtp"
    },
    searchCompanyByPhoneNumber: "searchCompanyByPhoneNumber",
    kyc: {
        getAadhaarOtp: "getAadhaarOtp",
        verifyAadhaarOtp: "verifyAadhaarOtp",
        verifyPanNumber: "verifyPanNumber",
        getGstOtp: "getGstOtp",
        verifyGstOtp: "verifyGstOtp"
    },
    getCompanyPostingAndBiddingLimit: "get-company-posting-and-bidding-limit",
    getDocuments: "getDocuments",
    deleteDocuments: "deleteDocuments",
    getDocumentsNonMutate: "getDocumentsNonMutate",
    callMeBackMutate: "callMeBackMutate",
    helpRequest: "helpRequest",
    userActionValidation: "userActionValidation",
    dashboardUser: {
        getCSUsers: "getCSUsers",
        getCSUserDetails: "getCSUserDetails",
        getCSRoles: "getCSRoles",
        getCSOperations: "getCSOperations",
        getCSRoleOperations: "getCSRoleOperations",
        updateCSRoleOperations: "updateCSRoleOperations",
        addCSUser: "addCSUser",
        editCSUser: "editCSUser",
        deleteCSUser: "deleteCSUser",
        getTaggedUserTSO: "getTaggedUserTSO",
        reassignLoad: "reassignLoad",
        getAttendance: "getAttendance",
        updateAttendance: "updateAttendance",
        getCSTeamStatus: "getCSTeamStatus"
    },
    GetLoadLorryPostingBiddingCounts: "GetLoadLorryPostingBiddingCounts",
    vas: {
        getVASPlans: "getVASPlans",
        getVASPlanById: "getVASPlanById",
        sendVasPaymentLink: "sendVasPaymentLink",
        buyVASPlans: "buyVASPlans",

        // membership
        membershipHistory: "membershipHistory",
        membershipRecent: "membershipRecent",

        // GPS
        getGpsHistory: "getGpsHistory",
        vasAddGPS: "vasAddGPS",
        vasGpsState: "vasGpsState",
        // cargo
        getCargoHistory: "getCargoHistory",
        getCargoPremium: "getCargoPremium",
        vasAddCargo: "vasAddCargo",
        vasCargoMaterialsList: "vasCargoMaterialsList"
    },
    updateRemarks: "updateRemarks",
    membership: {
        getMembershipPlans: "getMembershipPlans"
    },
    getMarketLoadList: "getMarketLoadList",
    getLoadAllData: "getLoadAllData",
    getLorryAllDataV2: "getLorryAllDataV2",
    getAllLorryDataInfinityQueryV2: "getAllLorryDataInfinityQueryV2",
    bank: {
        getBankDetails: "getBankDetails",
        addNew: "addNew"
    },
    generateBill: "generateBill",
    bidsPaymentsInfo: "bidsPaymentsInfo",
    pastLoads: "pastLoads",
    priceRecommendation: "priceRecommendation",
    popularLane: "popularLane",
    popularCities: "popularCities",
    companyRoutes: "companyRoutes",
    nearByCities: "nearByCities",
    reportSystem: {
        paymentReportSystem: "paymentReportSystem"
    },
    userProfileDisposition: "userProfileDisposition",
    getProfileDisposition: "getProfileDisposition",
    load: {
        updateExpectedAmount: "updateExpectedAmount",
        preferredAmount: "preferredAmount",
        cancel: "cancel"
    },
    bid: {
        bookingAmount: "bookingAmount"
    },
    adminDashboard: {
        notify: "notify"
    },
    generatePayment: "generatePayment",
    searchLocation: "searchLocation",
    payment: {
        cashBackLimit: "cashbackLimit",
        ledger: "ledger",
        calculatePaymentBreakup: "calculatePaymentBreakup"
    },
    tso: {
        checkInAndOut: "tso-check-in-and-out",
        sessions: "tso-sessions"
    },
    call: {
        initiate: "initiate",
        conferenceInitiate: "conferenceInitiate",
        conferenceEnd: "conferenceEnd",
        conferenceKick: "conferenceKick"
    }
};
